var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{class:_vm.classes},_vm._l((_vm.points),function(point,idx){return _c('li',{key:idx},[_c('shared-description-group',{attrs:{"description":point,"padded":_vm.padded}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }